import React from "react";
import classNames from "classnames";
import { ChevronUp } from "react-ikonate";
import { TableSortValue } from "shared/TableSortHeader";
import TableFilterDropdown from "../TableFilterDropdown";
import styles from "./index.module.css";

export default function TableFilterSortHeader({
  title,
  options,
  selectedValues,
  implicitCheckedValues,
  isExplicitSelection,
  onFilterChange,
  onMenuStateChange,
  sortValue,
  onSortChange,
}) {
  const onSortClick = (event) => {
    event.preventDefault();

    switch (sortValue) {
      case TableSortValue.ascending:
        onSortChange(TableSortValue.descending);
        break;
      case TableSortValue.descending:
      default:
        onSortChange(TableSortValue.ascending);
        break;
    }
  };

  return (
    <div className={styles.container}>
      <TableFilterDropdown
        title={title}
        options={options}
        selectedValues={selectedValues}
        implicitCheckedValues={implicitCheckedValues}
        isExplicitSelection={isExplicitSelection}
        onChange={onFilterChange}
        onMenuStateChange={onMenuStateChange}
        className={styles.dropdown}
      />

      <button className={styles.sortButton} onClick={onSortClick}>
        <div className={styles.indicator}>
          {sortValue === TableSortValue.ascending && (
            <ChevronUp className={styles.icon} />
          )}
          {sortValue === TableSortValue.descending && (
            <ChevronUp className={classNames(styles.icon, styles.reverse)} />
          )}
        </div>
      </button>
    </div>
  );
}
